function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1058_3561)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.704 36.72C21 36.684 13.836 39.776 8.372 45.24C6.288 47.324 4.456 49.756 3.04 52.488C7.968 48.756 13.228 47.588 19.384 51.044C21.196 46.248 23.608 41.372 26.704 36.72ZM59.32 69.292C54.264 72.596 49.296 74.98 44.996 76.66C48.448 82.82 47.28 88.072 43.552 93C46.288 91.588 48.716 89.752 50.8 87.664C56.28 82.188 59.376 75.004 59.32 69.292ZM79.828 16.14C78.452 16.044 77.104 16 75.784 16C47.108 16 30.788 37.86 24.852 55.44L40.608 71.2C58.708 64.72 80 49.004 80 20.632C80 19.168 79.944 17.672 79.828 16.14ZM46.868 49.172C45.564 47.872 45.564 45.76 46.868 44.46C48.168 43.156 50.28 43.156 51.58 44.46C52.884 45.764 52.884 47.872 51.58 49.172C50.276 50.476 48.168 50.476 46.868 49.172ZM56.292 39.748C53.688 37.148 53.688 32.924 56.292 30.32C58.896 27.716 63.116 27.716 65.716 30.32C68.32 32.924 68.32 37.144 65.716 39.748C63.116 42.348 58.9 42.348 56.292 39.748ZM6.564 81.26L3.544 78.24L20.904 60.948L23.924 63.968L6.564 81.26ZM23.16 87.448L20.14 84.428L32.256 72.212L35.276 75.232L23.16 87.448ZM3.02 96L0 92.98L21.492 71.524L24.516 74.544L3.02 96Z",
  fill: "url(#paint0_linear_1058_3561)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.352 38.836C86.6 41.308 84.66 43.244 82.188 44C84.66 44.752 86.6 46.688 87.352 49.164C88.108 46.688 90.044 44.752 92.516 44C90.044 43.248 88.108 41.312 87.352 38.836ZM28.732 12.82C27.744 16.06 25.208 18.592 21.972 19.58C25.212 20.568 27.744 23.104 28.732 26.34C29.724 23.104 32.256 20.568 35.492 19.58C32.252 18.592 29.724 16.06 28.732 12.82ZM21.424 0C20.628 2.596 18.6 4.628 16 5.42C18.6 6.216 20.628 8.248 21.424 10.84C22.216 8.244 24.248 6.212 26.84 5.42C24.248 4.628 22.22 2.596 21.424 0ZM42.972 0C41.708 4.14 38.464 7.384 34.32 8.652C38.464 9.916 41.708 13.156 42.972 17.304C44.236 13.16 47.48 9.92 51.62 8.652C47.48 7.384 44.24 4.14 42.972 0ZM87.352 54.56C86.088 58.704 82.844 61.944 78.7 63.212C82.844 64.476 86.088 67.86 87.352 72C88.616 67.856 91.86 64.476 96 63.212C91.86 61.944 88.616 58.704 87.352 54.56Z",
  fill: "#6EE7B7"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1058_3561",
  x1: 80,
  y1: 16,
  x2: 0.00000476837,
  y2: 96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2658EB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EB26D7"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1058_3561"
}, /*#__PURE__*/React.createElement("rect", {
  width: 96,
  height: 96,
  fill: "white"
})));

function SvgFinishedSucceedImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedSucceedImage);
export default __webpack_public_path__ + "static/media/finishedSucceedImage.2be661dc555f6eb84461b125f100ce64.svg";
export { ForwardRef as ReactComponent };